<template>
  <div class="lobby-single">
    <div class="container">
      <div :class="`match-header ${lobby.map}`">
        <div class="match-details-grid">
          <div class="team team_a">
            <span v-if="lobby.is_pug">{{ lobby.team1_name }}</span>
            <span v-else>
              <b-img
                :src="lobby.team_a.avatar.url"
                v-if="lobby.team_a && lobby.team_a.avatar"
                rounded
                width="75"
                height="75"
              />
              <div v-html="lobby.team_a.name" v-if="lobby.team_a && lobby.team_a.name"></div>
            </span>
          </div>
          <div class="score score_team_a">{{ lobby.team1_score }}</div>
          <div class="versus">
            <p>{{ lobby.status }}</p>x
          </div>
          <div class="score score_team_b">{{ lobby.team2_score }}</div>
          <div class="team team_b">
            <span v-if="lobby.is_pug">{{ lobby.team2_name }}</span>
            <span v-else>
              <b-img
                :src="lobby.team_b.avatar.url"
                v-if="lobby.team_b && lobby.team_b.avatar"
                rounded
                width="75"
                height="75"
              />
              <div v-html="lobby.team_b.name" v-if="lobby.team_b && lobby.team_b.name"></div>
            </span>
          </div>
        </div>

        <div class="match-details-list">
          <div class="match-info match-date">
            <span class="info-title">Data</span>
            {{ lobby.start_time_friendly }}
          </div>

          <div class="match-info match-tournament" v-if="lobby.tournament">
            <span class="info-title">Campeonato</span>
            <router-link
              :to="{ name: 'TournamentSingle', params: { id: lobby.tournament.to_param }}"
            >{{ lobby.tournament.name }}</router-link>
          </div>

          <div class="match-info map">
            <span class="info-title">Mapa</span>
            {{ lobby.map }}
          </div>

          <div
            class="match-info gotv"
            v-if="['match-launching', 'match-ready'].includes(lobby.status) && lobby.pug_server && lobby.pug_server.gotv_ip"
          >
            <span class="info-title">Gotv</span>
            <a :href="`steam://connect/${lobby.pug_server.gotv_ip}`">{{ lobby.pug_server.gotv_ip }}</a>
          </div>

          <div
            class="match-info server"
            v-if="['match-launching', 'match-ready'].includes(lobby.status) && lobby.current_user_has_access"
          >
            <span class="info-title">Conecte ao Servidor</span>
            <a :href="`steam://run/730//+connect ${lobby.pug_server.ip} +password ${lobby.pug_server.server_password}`">{{ lobby.pug_server.ip }}</a>
          </div>

          <div class="match-info demo">
            <span class="info-title">Demo</span>
            <a v-if="lobby.demofile_url && lobby.demofile_url.url" :href="lobby.demofile_url.url">Baixar demo</a>
            <span
              v-else
              v-b-tooltip.hover
              title="disponível depois de 5 minutos do final da partida"
            >aguarde</span>
          </div>

          <div class="match-info fightback" v-if="lobby.fightback_embed">
            <span class="info-title">Replay FIGHTBACK</span>
            <a href="#fightback-player">Assista aqui</a>
          </div>
        </div>
      </div>
      <!-- <section class="hero is-dark match-hero <%= @lobby.try(:map) %>"> -->

      <div class="fightback-player" v-if="lobby.fightback_embed">
        <a name="fightback-player"></a>
        <div class="responsive-fightback-embed">
          <iframe
            width="100%"
            height="600"
            :src="lobby.fightback_embed"
            scrolling="no"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <div
        class="stats-table table-responsive"
        v-if="lobby.stats_team_a.length > 0 && lobby.stats_team_b.length > 0"
      >
        <table class="table is-hoverable team1">
          <thead>
            <tr>
              <th style="width: 300px">
                <span v-if="lobby.is_pug">{{ lobby.team1_name }}</span>
                <span v-else>
                  <router-link
                    :to="{ name: 'TeamSingle', params: { id: lobby.team_a.id }}"
                    v-if="lobby.team_a"
                  >{{ lobby.team_a.name }}</router-link>
                </span>
              </th>
              <th>
                <abbr title="inimigos mortos">Kills</abbr>
              </th>
              <th>
                <abbr title="vezes que você morreu">Deaths</abbr>
              </th>
              <th>
                <abbr title="porcentagem de headshots">HS %</abbr>
              </th>
              <th>
                <abbr title="inimigos mortos por round">KDR</abbr>
              </th>
              <th>
                <abbr title="dano médio por round">ADR</abbr>
              </th>
              <th>
                <abbr title="clutches">1vsX</abbr>
              </th>
              <th>
                <abbr title="flashbang assists">BA</abbr>
              </th>
              <th>
                <abbr title="matou 3 no round">3K</abbr>
              </th>
              <th>
                <abbr title="matou 4 no round">4K</abbr>
              </th>
              <th>
                <abbr title="matou o time adversário todo">ACE</abbr>
              </th>
              <th>
                <abbr title="mortes que você vingou">Trades</abbr>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stat in lobby.stats_team_a" :key="stat.id">
              <td v-if="stat.user" class="user-column">
                <router-link :to="{ name: 'UserSingle', params: { id: stat.user.id }}">
                  <div class="user-image">
                    <b-img-lazy
                      rounded="circle"
                      :src="stat.user.avatar.url"
                      :alt="stat.nickname"
                      v-if="stat.user.avatar"
                    />
                  </div>
                  <span>{{ stat.user.nickname }}</span>
                </router-link>
              </td>
              <td v-else>{{ stat.user_id }}</td>
              <td>{{ stat.kills }}</td>
              <td>{{ stat.deaths }}</td>
              <td>{{ stat.headshot_percentage }}</td>
              <td>{{ stat.kdr }}</td>
              <td>{{ stat.adr }}</td>
              <td>{{ stat.clutches }}</td>
              <td>{{ stat.flashbang_assists }}</td>
              <td>{{ stat.k3 }}</td>
              <td>{{ stat.k4 }}</td>
              <td>{{ stat.k5 }}</td>
              <td>{{ stat.tradekills }}</td>
            </tr>
          </tbody>
        </table>

        <table class="table is-hoverable team2 responsive">
          <thead>
            <tr>
              <th style="width: 300px">
                <span v-if="lobby.is_pug">{{ lobby.team2_name }}</span>
                <span v-else>
                  <router-link
                    :to="{ name: 'TeamSingle', params: { id: lobby.team_b.id }}"
                    v-if="lobby.team_b"
                  >{{ lobby.team_b.name }}</router-link>
                </span>
              </th>
              <th>
                <abbr title="inimigos mortos">Kills</abbr>
              </th>
              <th>
                <abbr title="vezes que você morreu">Deaths</abbr>
              </th>
              <th>
                <abbr title="porcentagem de headshots">HS %</abbr>
              </th>
              <th>
                <abbr title="inimigos mortos por round">KDR</abbr>
              </th>
              <th>
                <abbr title="dano médio por round">ADR</abbr>
              </th>
              <th>
                <abbr title="clutches">1vsX</abbr>
              </th>
              <th>
                <abbr title="flashbang assists">BA</abbr>
              </th>
              <th>
                <abbr title="matou 3 no round">3K</abbr>
              </th>
              <th>
                <abbr title="matou 4 no round">4K</abbr>
              </th>
              <th>
                <abbr title="matou o time adversário todo">ACE</abbr>
              </th>
              <th>
                <abbr title="mortes que você vingou">Trades</abbr>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stat in lobby.stats_team_b" :key="stat.id">
              <td v-if="stat.user" class="user-column">
                <router-link :to="{ name: 'UserSingle', params: { id: stat.user.id }}">
                  <div class="user-image">
                    <b-img-lazy
                      rounded="circle"
                      :src="stat.user.avatar.url"
                      :alt="stat.nickname"
                      v-if="stat.user.avatar"
                    />
                  </div>
                  <span>{{ stat.user.nickname }}</span>
                </router-link>
              </td>
              <td v-else>{{ stat.user_id }}</td>
              <td>{{ stat.kills }}</td>
              <td>{{ stat.deaths }}</td>
              <td>{{ stat.headshot_percentage }}</td>
              <td>{{ stat.kdr }}</td>
              <td>{{ stat.adr }}</td>
              <td>{{ stat.clutches }}</td>
              <td>{{ stat.flashbang_assists }}</td>
              <td>{{ stat.k3 }}</td>
              <td>{{ stat.k4 }}</td>
              <td>{{ stat.k5 }}</td>
              <td>{{ stat.tradekills }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="stats-table table-responsive" v-else>
        <table class="table is-hoverable team1">
          <thead>
            <tr>
              <th style="width: 300px">
                <span v-if="lobby.is_pug">{{ lobby.team1_name }}</span>
                <span v-else>
                  <router-link
                    :to="{ name: 'TeamSingle', params: { id: lobby.team_a.id }}"
                    v-if="lobby.team_a"
                  >{{ lobby.team_a.name }}</router-link>
                </span>
              </th>
              <th>
                <abbr title="inimigos mortos">Kills</abbr>
              </th>
              <th>
                <abbr title="vezes que você morreu">Deaths</abbr>
              </th>
              <th>
                <abbr title="porcentagem de headshots">HS %</abbr>
              </th>
              <th>
                <abbr title="inimigos mortos por round">KDR</abbr>
              </th>
              <th>
                <abbr title="dano médio por round">ADR</abbr>
              </th>
              <th>
                <abbr title="clutches">1vsX</abbr>
              </th>
              <th>
                <abbr title="flashbang assists">BA</abbr>
              </th>
              <th>
                <abbr title="matou 3 no round">3K</abbr>
              </th>
              <th>
                <abbr title="matou 4 no round">4K</abbr>
              </th>
              <th>
                <abbr title="matou o time adversário todo">ACE</abbr>
              </th>
              <th>
                <abbr title="mortes que você vingou">Trades</abbr>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stat in lobby.lobby_users_a" :key="stat.id">
              <td colspan="11" class="user-column">
                <router-link :to="{ name: 'UserSingle', params: { id: stat.to_param }}">
                  <div class="user-image">
                    <b-img-lazy
                      rounded="circle"
                      :src="stat.user.avatar.url"
                      :alt="stat.nickname"
                      v-if="stat.user.avatar"
                    />
                  </div>
                  <span>{{ stat.user.nickname }}</span>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table is-hoverable team2 responsive">
          <thead>
            <tr>
              <th style="width: 300px">
                <span v-if="lobby.is_pug">{{ lobby.team2_name }}</span>
                <span v-else>
                  <router-link
                    :to="{ name: 'TeamSingle', params: { id: lobby.team_b.id }}"
                    v-if="lobby.team_b"
                  >{{ lobby.team_b.name }}</router-link>
                </span>
              </th>
              <th>
                <abbr title="inimigos mortos">Kills</abbr>
              </th>
              <th>
                <abbr title="vezes que você morreu">Deaths</abbr>
              </th>
              <th>
                <abbr title="porcentagem de headshots">HS %</abbr>
              </th>
              <th>
                <abbr title="inimigos mortos por round">KDR</abbr>
              </th>
              <th>
                <abbr title="dano médio por round">ADR</abbr>
              </th>
              <th>
                <abbr title="clutches">1vsX</abbr>
              </th>
              <th>
                <abbr title="flashbang assists">BA</abbr>
              </th>
              <th>
                <abbr title="matou 3 no round">3K</abbr>
              </th>
              <th>
                <abbr title="matou 4 no round">4K</abbr>
              </th>
              <th>
                <abbr title="matou o time adversário todo">ACE</abbr>
              </th>
              <th>
                <abbr title="mortes que você vingou">Trades</abbr>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stat in lobby.lobby_users_b" :key="stat.id">
              <td colspan="11" class="user-column">
                <router-link :to="{ name: 'UserSingle', params: { id: stat.to_param }}">
                  <div class="user-image">
                    <b-img-lazy
                      rounded="circle"
                      :src="stat.user.avatar.url"
                      :alt="stat.nickname"
                      v-if="stat.user.avatar"
                    />
                  </div>
                  <span>{{ stat.user.nickname }}</span>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!--<div class="fightback-player-cta" v-if="lobby.fightback_embed">
        <a name="fightback-player"></a>
        <div class="logo-container">
          <a href="https://fightback.club" target="_blank"><b-img src="/img/fightback-logo-white.png" alt="FIGHTBACK.club logo" /></a>
        </div>
        <div class="info">
          <h3>Replay da Partida <strong>by FIGHTBACK.club</strong></h3>
          <p>
            Em parceria com o FIGHTBACK.club, você pode visualizar o replay desta partida abaixo.
          </p>
          <p>
            <a href="https://fightback.club" target="_blank">Visite AGORA e conheça as ferramentas para <strong>melhorar o seu jogo</strong></a>.
          </p>
        </div>
      </div>-->
      
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";
export default {
  name: "LobbySingle",
  metaInfo: {
    title: "Visualizando partida"
  },
  data() {
    return {
      lobby: { cover: "", id: 0, stats_team_a: [], stats_team_b: [] }
    };
  },
  methods: {
    initialize() {
      this.$http
        .get("lobbies/" + this.$route.params.id + ".json")
        .then(response => (this.lobby = response.data));
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    PageHeader
  }
};
</script>

<style lang="sass" scoped>
.match-header
  color: white
.match-details-grid
  width: 100%
  padding: 20px 100px
  min-height: 120px
  display: grid
  grid-gap: 0
  grid-template-columns: [col] 30% [col] 15% [col] 10% [col] 15% [col] 30%
  grid-template-rows: [row] auto
  text-align: center
  align-items: flex-end

  font-size: 34px
  font-weight: bold
  
  background: rgba(0, 0, 0, .1)

  @media (max-width: 600px)
    padding: 10px
    font-size: 20px

  .versus
    font-size: 13px

  .team
    div
      font-size: 18px
      // color: white


.user-column
  // display: flex
  padding: 0.5em 0.45em !important
  .user-image
    display: inline-block
    margin-right: 10px
    img
      width: 28px
      height: 28px
  span
    display: inline-block
    position: relative
    top: 3px

.match-details-list 
  display: flex
  justify-content: center
  // margin-top: 40px
  background: rgba(0, 0, 0, .4)
  .match-info 
    font-size: 16px
    margin: 10px 10px 10px 0
    color: rgba(255, 255, 255, 0.9)
    padding: 0 10px 0 0

    &:not(:last-of-type)
      border-right: 1px solid rgba(255, 255, 255, .2)

    .info-title 
      display: block
      font-weight: bold
      text-transform: uppercase
      font-size: 14px
      color: rgba(255, 255, 255, 0.6)

  a
    color: #eee

      
.fightback-certified 
  position: absolute
  bottom: 0
  right: 0
  width: 190px
  a
    img
      opacity: .4
      transition: all .3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    &:hover
      img
        opacity: 1
        transform: scale(1.1)

.fightback-player-cta
  display: flex
  width: 100%
  // height: 180px
  background: rgb(144, 25, 25)
  background: linear-gradient(65deg, rgba(144, 25, 25, 0.75) 0%, rgba(34, 5, 5, 0.2) 70%, rgba(0, 0, 0, 0) 100%)
  padding: 20px
  border-radius: 10px 0 0 10px
  margin-bottom: 20px

  .logo-container
    width: 160px
    img
      width: 100%
      height: auto

  .info
    color: rgba(255, 255, 255, .7)
    padding: 20px
    line-height: 125%
    h3
      color: rgba(255, 255, 255, .7)
      strong
        font-size: 18px
        color: white

    p
      font-size: 16px

    a:hover
      font-weight: bold
      color: white

</style>
